import { Card } from '@/pages/settings/components/card';
import { useSessionContext } from '@/contexts/session/context';
import styles from './index.module.scss';
import UserNameIcon from './images/userName.svg?react';

const Profile = () => {
  const { showProfileInfo } = useSessionContext();
  const { info } = showProfileInfo;
  const data = [
    {
      title: 'Basic Information',
      data: [
        {
          key: '1',
          icon: <UserNameIcon />,
          title: 'UserName',
          showBottom: true,
          extra: <div>@{info.username}</div>,
        },
      ],
    },
  ];
  return (
    <div className={styles.profile}>
      {data.map((item, index) => {
        return (
          <Card
            className={styles.card}
            key={index}
            title={item.title}
            data={item.data}
          ></Card>
        );
      })}
    </div>
  );
};

export default Profile;
